import { render } from "./manager_dashboard.vue?vue&type=template&id=47977178&scoped=true&ts=true"
import script from "./manager_dashboard.vue?vue&type=script&lang=ts"
export * from "./manager_dashboard.vue?vue&type=script&lang=ts"

import "./manager_dashboard.vue?vue&type=style&index=0&id=47977178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47977178"]])

export default __exports__